import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import CreateTaskTitleLabel from 'automation-ui-action-features/actions/create-task/CreateTaskTitleLabel';
import CreateTaskOwnerLabel from 'automation-ui-action-features/actions/create-task/CreateTaskOwnerLabel';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CreateTaskActionSummary({
  actionMetadata,
  flowObjectTypeId
}) {
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.create-task.summary",
    options: {
      subject: /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(CreateTaskTitleLabel, {
          actionMetadata: actionMetadata,
          flowObjectTypeId: flowObjectTypeId
        })
      }),
      owner: /*#__PURE__*/_jsx(CreateTaskOwnerLabel, {
        actionMetadata: actionMetadata,
        flowObjectTypeId: flowObjectTypeId
      })
    }
  });
}